package com.gsb.vyapar.bhagya.util

import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.updateState
import com.gsb.vyapar.bhagya.presentation.dialog.Dialogs
import com.gsb.vyapar.bhagya.presentation.dialog.uistate.DialogUiState

fun showExitPopup(exitApp: (Boolean) -> Unit) {
    updateState(getState().copy(dialogUiState = DialogUiState(dialogType = Dialogs.Regular, message = "Are you sure you want to exit?", onCancelClick = {
        updateState(getState().copy(dialogUiState = null))
        exitApp(false)
    }, onOKClick = {
        updateState(getState().copy(dialogUiState = null))
        exitApp(true)
    })))
}